import { SurveyPricingSnapshot } from '@ps/survey-utils';
import { Undefinable } from '@ps/utils';

import { InsightsChildState } from '../../insights/survey-creation-insights-state.model';

/** The shared pricing, with this locale's own feasibility CPI applied. */
export function childPricing(
  pricing: SurveyPricingSnapshot,
  insights: Undefinable<InsightsChildState>,
): SurveyPricingSnapshot {
  return {
    ...pricing,
    feasibilityCpi: insights?.feasibility.cpi ?? pricing.feasibilityCpi,
  };
}

export function localePricing(
  pricing: SurveyPricingSnapshot,
  insights: Undefinable<InsightsChildState>,
): SurveyPricingSnapshot {
  return {
    ...childPricing(pricing, insights),
    ...insights?.pricing,
  };
}
